export default __webpack_public_path__ + "static/media/social-telegram-icon.5b4df1cf.svg";